import RibbonPriceUp from '../RibbonPriceUp';
import RibbonPriceDown from '../RibbonPriceDown';

const StatusProductProps = {
  price_up: <RibbonPriceUp />,
  price_down: <RibbonPriceDown />,
  not_change: null,
};

export default StatusProductProps;
